export const handleUpdateUserProfileError = (error) => {
  if (error.message.includes('mobileContactNumber')) {
    return { message: 'Please enter valid phone number' }
  } else {
    throw error
  }
}
